import { Context, useContext } from 'react';

export const useRequiredContext = <T>(
  context: Context<T | undefined>,
  errorMessage?: string,
): T => {
  const result = useContext(context);

  if (result === undefined)
    throw new Error(
      errorMessage ??
        `Required context ${context.displayName ?? ''} is not present`,
    );

  return result;
};
